import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  TextField,
  Button,
  Paper,
  Typography,
  CircularProgress,
  Container,
  Grid,
} from '@mui/material';

const ProveedorForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = Boolean(id);

  const [formData, setFormData] = useState({
    nombre_fiscal: '',
    rfc: '',
    direccion: '',
    telefono: '',
    correo_electronico: '',
    banco: '',
    numero_cuenta: '',
    clabe: '',
    beneficiario: '',
    agente_ventas: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isEditMode) {
      setLoading(true);
      axios.get(`/api/proveedores/${id}`)
        .then(response => {
          setFormData(response.data);
          setLoading(false);
        })
        .catch(err => {
          setError('No se pudo cargar el proveedor para editar.');
          console.error(err);
          setLoading(false);
        });
    }
  }, [id, isEditMode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const dataToSend = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => [key, value || null])
    );

    try {
      if (isEditMode) {
        const { id, ...updateData } = dataToSend;
        await axios.put(`/api/proveedores/${id}`, updateData);
        navigate(`/proveedores/${id}`);
      } else {
        await axios.post('/api/proveedores', dataToSend);
        navigate('/proveedores');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'No se pudo guardar el proveedor. Verifique los datos.');
      console.error(err);
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 3, mt: 4 }}>
        <Typography variant="h5" gutterBottom>
          {isEditMode ? 'Editar Proveedor' : 'Crear Nuevo Proveedor'}
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                name="nombre_fiscal"
                label="Nombre Fiscal o Razón Social"
                value={formData.nombre_fiscal || ''}
                onChange={handleChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="rfc"
                label="RFC (Opcional)"
                value={formData.rfc || ''}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="direccion"
                label="Dirección"
                value={formData.direccion || ''}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="telefono"
                label="Teléfono"
                value={formData.telefono || ''}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="correo_electronico"
                label="Email"
                type="email"
                value={formData.correo_electronico || ''}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="agente_ventas"
                label="Agente de Ventas"
                value={formData.agente_ventas || ''}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          </Grid>

          <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
            Datos Bancarios (Opcional)
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                name="banco"
                label="Banco"
                value={formData.banco || ''}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="beneficiario"
                label="Beneficiario"
                value={formData.beneficiario || ''}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="numero_cuenta"
                label="Número de Cuenta"
                value={formData.numero_cuenta || ''}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="clabe"
                label="CLABE Interbancaria"
                value={formData.clabe || ''}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          </Grid>

          <Button type="submit" variant="contained" color="primary" sx={{ mt: 4 }}>
            {isEditMode ? 'Guardar Cambios' : 'Crear Proveedor'}
          </Button>
          {error && (
            <Typography color="error" sx={{ mt: 2 }}>
              {error}
            </Typography>
          )}
        </form>
      </Paper>
    </Container>
  );
};

export default ProveedorForm;
